/* eslint-disable no-unused-vars */
import dayjs from "dayjs";
import React, { useState } from "react";
import { toast } from "react-hot-toast";
import Select from "react-select";
import { corporateFundInfo } from "../../utils/services/users.services";
import Continue from "./Continue";

function CompanyBuisness({
  dictionary,
  countries,
  associatedRuleId,
  handleClose,
  customerId,
  title,
}) {
  const [loading, setLoading] = useState(false);
  const [licence, setlicence] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [formData, setFormData] = useState([
    {
      industry: "",
      licence: licence,
      bussinessLogic: "",
      previousYearTurnOver: 0,
      accountPurpose: "",
      sourceOfFund: "",
      monthlyTurnOverOnIncome: 0,
      numberOfMonthlyTransactionOnIncome: 0,
      transactionCountryOnIncomingTransaction: "",
      monthlyTurnOverOnOutgoing: 0,
      numberOfMonthlyTransactionOnOutgoing: 0,
      transactionCountryOnOutgoingTransaction: "",
      turnOverPlannedForComingYear: "",
      mainBussinessRegion: "",
    },
  ]);

  const handleFormChange = (e, index) => {
    let data = [...formData];
    data[index][e.target.name] = e.target.value || e.target.checked;
    setFormData(data);
    if (
      data[index].industry !== "" &&
      data[index].accountPurpose !== "" &&
      data[index].bussinessLogic !== "" &&
      data[index].mainBussinessRegion !== "" &&
      data[index].monthlyTurnOverOnIncome > 0 &&
      data[index].numberOfMonthlyTransactionOnIncome > 0 &&
      data[index].monthlyTurnOverOnOutgoing > 0 &&
      data[index].numberOfMonthlyTransactionOnOutgoing > 0 &&
      data[index].previousYearTurnOver > 0
    ) {
      setDisabled(false);
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);

    const payload = data.map((data) => {
      return {
        industry: data.industry,
        licence: data.licence,
        bussinessLogic: data.bussinessLogic,
        previousYearTurnOver: parseFloat(data.previousYearTurnOver),
        accountPurpose: data.accountPurpose,
        sourceOfFund: data.sourceOfFund,
        monthlyTurnOverOnIncome: parseFloat(data.monthlyTurnOverOnIncome),
        numberOfMonthlyTransactionOnIncome: parseFloat(
          data.numberOfMonthlyTransactionOnIncome
        ),
        transactionCountryOnIncomingTransaction:
          data.transactionCountryOnIncomingTransaction,
        monthlyTurnOverOnOutgoing: parseFloat(data.monthlyTurnOverOnOutgoing),
        numberOfMonthlyTransactionOnOutgoing: parseFloat(
          data.numberOfMonthlyTransactionOnOutgoing
        ),
        transactionCountryOnOutgoingTransaction:
          data.transactionCountryOnOutgoingTransaction,
        turnOverPlannedForComingYear: data.turnOverPlannedForComingYear,
        mainBussinessRegion: data.mainBussinessRegion,
      };
    });

    const coporatePayload = { roles: payload };

    try {
      const response = await corporateFundInfo(coporatePayload);
      if (response.status === 200) {
        setLoading(false);
        handleClose();
        toast.success(response.data.message);
        setFormData([
          {
            industry: "",
            licence: true,
            bussinessLogic: "",
            previousYearTurnOver: 0,
            accountPurpose: "",
            sourceOfFund: "",
            monthlyTurnOverOnIncome: 0,
            numberOfMonthlyTransactionOnIncome: 0,
            transactionCountryOnIncomingTransaction: "",
            monthlyTurnOverOnOutgoing: 0,
            numberOfMonthlyTransactionOnOutgoing: 0,
            transactionCountryOnOutgoingTransaction: "",
            mainBussinessRegion: "",
          },
        ]);
      }
    } catch (error) {
      return error;
    }
    setLoading(false);
  };
  return (
    <form
      className="needs-validation pt-1 ms-5 ps-5"
      onSubmit={(e) => e.preventDefault()}
    >
      <h5 className="title">{title}</h5>
      {formData.map((i, index) => {
        return (
          <>
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12 mb-3">
                <input
                  name="industry"
                  id="industry"
                  type={"text"}
                  className="form-control"
                  onChange={(e) => {
                    handleFormChange(e, index);
                  }}
                  placeholder={"Industry"}
                />
              </div>
            </div>

            <div className="row">
              <div className="row ps-5">
                <div className="col-xl-12 col-lg-12 col-md-12 mb-3 py-3">
                  <input
                    type="checkbox"
                    name="licence"
                    id="licence"
                    className={`ps-3 me-2 check-box`}
                    onChange={(e) => {
                      // handleFormChange(e, index);
                      setlicence(e.target.checked);
                    }}
                  />
                  <span className="ps-2 subtitle align-bottom">
                    Does the company have an active license?
                  </span>
                </div>
              </div>
            </div>

            <p className="subtitle">
              Briefly describe your business model and company activity as well
              as revenue streams and any other information that might be
              relevant in understanding the business of the company in one or
              two paragraphs (if relevant, please provide history of activities,
              media publications we should be aware about)
            </p>

            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12 mb-3">
                <textarea
                  id="bussinessLogic"
                  name="bussinessLogic"
                  className="form-control text-area"
                  placeholder={"Enter"}
                  onChange={(e) => handleFormChange(e, index)}
                />
              </div>
            </div>

            <div className="row mt-3 mb-3">
              <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                <input
                  name="mainBussinessRegion"
                  id="mainBussinessRegion"
                  type={"text"}
                  className="form-control"
                  onChange={(e) => {
                    handleFormChange(e, index);
                  }}
                  placeholder={"Main business regions"}
                />
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                <input
                  type="number"
                  name="previousYearTurnOver"
                  id="previousYearTurnOver"
                  className={`form-control name-fields ps-3`}
                  onChange={(e) => {
                    handleFormChange(e, index);
                  }}
                  placeholder={"Previous year turnover"}
                  required
                />
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                <input
                  type="text"
                  name="turnOverPlannedForComingYear"
                  id="turnOverPlannedForComingYear"
                  className={`form-control name-fields ps-3`}
                  onChange={(e) => {
                    handleFormChange(e, index);
                  }}
                  placeholder={"Next year planned turnover"}
                  required
                />
              </div>
            </div>

            <div className="row mt-3 mb-3">
              <div className="col-xl-6 col-lg-6 col-md-6 mb-3">
                <textarea
                  id="accountPurpose"
                  name="accountPurpose"
                  className="form-control text-area"
                  onChange={(e) => {
                    handleFormChange(e, index);
                  }}
                  placeholder={"Purpose for account opening"}
                />
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 mb-3">
                <textarea
                  id="sourceOfFund"
                  name="sourceOfFund"
                  className="form-control text-area"
                  onChange={(e) => {
                    handleFormChange(e, index);
                  }}
                  placeholder={"Source of Customers Funds "}
                />
              </div>
            </div>

            <p className="subtitle mt-3">Incoming Transactions</p>
            <div className="row mb-3">
              <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                <input
                  type="number"
                  name="monthlyTurnOverOnIncome"
                  id="monthlyTurnOverOnIncome"
                  className={`form-control name-fields ps-3`}
                  onChange={(e) => {
                    handleFormChange(e, index);
                  }}
                  placeholder={"Monthly Turnover Income"}
                  required
                />
              </div>
              <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                <input
                  type="number"
                  name="numberOfMonthlyTransactionOnIncome"
                  id="numberOfMonthlyTransactionOnIncome"
                  className={`form-control name-fields ps-3`}
                  onChange={(e) => {
                    handleFormChange(e, index);
                  }}
                  placeholder={"Number of Monthly Transaction"}
                  required
                />
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                <Select
                  options={countries}
                  isClearable={false}
                  isSearchable={true}
                  maxMenuHeight={250}
                  menuPlacement="bottom"
                  name="transactionCountryOnIncomingTransaction"
                  onChange={(option) => {
                    const e = {
                      target: {
                        name: "transactionCountryOnIncomingTransaction",
                        value: option.iso3Code,
                      },
                    };
                    handleFormChange(e, index);
                  }}
                  placeholder={"Incoming Transaction Country"}
                />
              </div>
            </div>

            <p className="subtitle">Outgoing Transactions</p>
            <div className="row">
              <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                <input
                  type="number"
                  name="monthlyTurnOverOnOutgoing"
                  id="monthlyTurnOverOnOutgoing"
                  className={`form-control name-fields ps-3`}
                  onChange={(e) => handleFormChange(e, index)}
                  placeholder={"Monthly turnover"}
                  required
                />
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                <input
                  type="number"
                  name="numberOfMonthlyTransactionOnOutgoing"
                  id="numberOfMonthlyTransactionOnOutgoing"
                  className={`form-control name-fields ps-3`}
                  onChange={(e) => {
                    handleFormChange(e, index);
                  }}
                  placeholder={"Number of Monthly Transactions"}
                  required
                />
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4 mb-3">
                <Select
                  options={countries}
                  isClearable={false}
                  isSearchable={true}
                  maxMenuHeight={250}
                  menuPlacement="bottom"
                  name="transactionCountryOnOutgoingTransaction"
                  onChange={(option) => {
                    const e = {
                      target: {
                        name: "transactionCountryOnOutgoingTransaction",
                        value: option.iso3Code,
                      },
                    };
                    handleFormChange(e, index);
                  }}
                  placeholder={"Outgoing Transacton Country"}
                />
              </div>
            </div>
          </>
        );
      })}

      <Continue
        dictionary={dictionary}
        onClick={() => {
          onSubmit(formData);
        }}
        loading={loading}
        disabled={disabled}
      />
    </form>
  );
}

export default CompanyBuisness;
